__turbopack_context__.v({
  "border": "modal-module__2rRlOG__border",
  "content": "modal-module__2rRlOG__content",
  "dialog": "modal-module__2rRlOG__dialog",
  "footer": "modal-module__2rRlOG__footer",
  "header": "modal-module__2rRlOG__header",
  "shadow": "modal-module__2rRlOG__shadow",
});
